export default {
    navigationBarTitleText: '法律声明',
};
